import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function AboutTrust() {
  const bullets = ['Boutique med spa in Miami', 'Personalized consultations', 'Professional, client-centered care', 'Beauty and wellness treatments tailored to individual goals'];
  return <section id="about" className="py-24 bg-brand-black relative overflow-hidden" data-id="element-17">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-brand-soft-black to-transparent opacity-50 pointer-events-none" data-id="element-18" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-19">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-21">
            <h2 className="font-heading text-3xl md:text-5xl text-brand-white mb-6 leading-tight" data-id="element-22">
              Where Beauty Meets{' '}
              <span className="text-brand-gold italic" data-id="element-23">Expertise</span>
            </h2>
            <div className="w-16 h-px bg-brand-gold mb-8" data-id="element-24"></div>

            <p className="text-brand-champagne-light/80 text-lg leading-relaxed mb-8 font-light" data-id="element-25">
              At Deluxe MedSpa Beauty, we combine a modern approach to
              aesthetics with personalized care. Our goal is to help each client
              feel confident, refreshed, and supported throughout their beauty
              journey in a luxurious and professional setting.
            </p>

            <ul className="space-y-4" data-id="element-26">
              {bullets.map((bullet, index) => <li key={index} className="flex items-start" data-id="element-27">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-gold mr-4 flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-28" />
                  <span className="text-brand-champagne-light/90" data-id="element-29">
                    {bullet}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-30">
            {/* Abstract luxury representation instead of image */}
            <div className="aspect-[4/5] bg-brand-charcoal border border-brand-gold/20 rounded-sm p-8 relative overflow-hidden flex flex-col justify-end" data-id="element-31">
              <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-transparent z-10" data-id="element-32" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[radial-gradient(circle_at_center,rgba(201,169,110,0.05)_0%,transparent_70%)]" data-id="element-33" />

              <div className="relative z-20 border-l-2 border-brand-gold pl-6 py-2" data-id="element-34">
                <p className="font-heading text-2xl text-brand-white mb-2" data-id="element-35">
                  "True luxury is peace of mind."
                </p>
                <p className="text-brand-gold text-sm uppercase tracking-widest" data-id="element-36">
                  Deluxe MedSpa Beauty
                </p>
              </div>
            </div>

            {/* Decorative frame */}
            <div className="absolute -inset-4 border border-brand-gold/10 rounded-sm pointer-events-none" data-id="element-37" />
          </motion.div>
        </div>
      </div>
    </section>;
}